<template>
	<div class="questionnaire_page">
		<!-- 标题面包屑 -->
		<div v-if="$route.params.handle == 'show' && isPc" class="layout-content-title">
			<div class="breadcrumb" @click="escPreview">
				<svg class="iconpark-icon"><use href="#tuichuyulan"></use></svg>
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item> 退出预览 </el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="handleBtn">
				<!-- <el-button type="primary" @click="submitForm()">
					{{ !questionnaireForm.status ? '发布' : '取消发布' }}
				</el-button> -->
			</div>
		</div>
		<div ref="questionnaireWrap" class="questionnaire_wrap" :class="{ questionnaire_wrap_pc: isPc }" />
		<custom-page v-if="isCustomNeedLoginQuestion" />
	</div>
</template>
<script>
import getQuery from '@/utils/getQuery';
import axios from 'axios';
import config from '@/config';
import CustomPage from '@/components/custom/customPage.vue';
export default {
	components: {
		CustomPage,
	},
	data() {
		return {
			parcel: null,
			isPc: window.innerWidth > 768,
			queryData: {},
		};
	},
	computed: {
		// 慈善总会定制
		isCharitableCustomLive() {
			// 测试直播间 测试环境： 58628 线上环境： 客户定制直播间：1527333 直播间定制相关当前清除
			/* 2022-12-05 客户新增需求，两个直播间，两个投票要分开
			 * 理事定制： 测试环境 83142 线上环境：直播间ID 2384514
			 * 常务理事定制： 测试环境 83143， 线上环境： 直播间ID 2384547
			 */
			const customLiveList = [83142, 83143, 2384514, 2384547];
			return (
				this.queryData &&
				this.queryData.activityId &&
				customLiveList.includes(Number(this.queryData.activityId))
			);
		},
		// 登录信息获取定制
		isCustomNeedLoginQuestion() {
			const customQuestionIdList = config.env === 'release' ? [6444, 6474] : [622, 623];
			return customQuestionIdList.includes(Number(this.$route.params.id));
		},
	},
	created() {
		this.getQueryData();
		this.$on('submit', this.submitSuccess);
	},
	async mounted() {
		const parcelProps = {
			serviceConfig: {
				local: process.env.NODE_ENV == 'development',
				apiPath: `${config.apiPath}/`,
				uploadPath: config.uploadHost,
				backendPath: `${config.Host}`,
				env: config.env,
			},
			domElement: this.$refs.questionnaireWrap,
			parentVm: this,
			environment: 'live',
			surveyId: this.$route.params.id,
			mode: this.isPc ? 'pc' : 'mobile',
			previewMode: this.$route.params.id == 'noId',
			disabled: this.$route.params.id == 'noId' || this.$route.query.preview,
			isPage: true,
		};
		console.log(parcelProps);
		const spa = await System.import('single-spa');
		this.parcel = spa.mountRootParcel(System.import('questionnaire'), parcelProps);
	},
	destroyed() {
		this.parcel.unmount();
		this.$off('submit', this.submitSuccess);
	},
	methods: {
		getQueryData() {
			const query = getQuery(location.href);
			this.queryData = query ? query : {};
		},
		submitSuccess(answerData) {
			// 慈善总会定制
			if (!this.isCharitableCustomLive) {
				return;
			}
			const requestURL = `https://charitable${config.env === 'beta' ? '-beta' : ''}.ourwill.cn/user/vote`;
			axios({
				url: requestURL,
				method: 'POST',
				data: {
					phone: this.queryData.phone,
					type: this.queryData.power,
					votes: answerData,
				},
			}).then((res) => {
				console.log(res);
				const { data } = res.data;
				if (data && data.code === 0) {
					const postData = {
						type: 1,
					};
					window.parent.postMessage(postData, '*');
				}
			});
		},
		escPreview() {
			var userAgent = navigator.userAgent;
			if (userAgent.indexOf('Firefox') != -1 || userAgent.indexOf('Chrome') != -1) {
				window.location.href = 'about:blank';
				window.close();
			} else {
				window.opener = null;
				window.open('', '_self');
				window.close();
			}
		},
	},
};
</script>
<style lang="less">
.questionnaire_page {
	height: 100%;
	background: rgba(242, 243, 245, 1);
	display: flex;
	flex-direction: column;
	.layout-content-title {
		position: relative;
		z-index: 10;
		height: 64px;
		padding: 16px 16px 16px 24px;
		font-size: 14px;
		box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: space-between;
		align-items: center;
		.breadcrumb {
			display: flex;
			align-items: center;
			cursor: pointer;
			.iconpark-icon {
				font-size: 20px;
				margin-right: 16px;
				fill: rgba(78, 89, 105, 1);
				cursor: pointer;
			}
			.el-breadcrumb__inner {
				color: rgba(78, 89, 105, 1);
				font-size: 18px;
				cursor: pointer;
			}
			.el-breadcrumb__separator {
				font-size: 16px;
			}
		}
		.handleBtn {
			display: flex;
			align-items: center;
			.el-button {
				height: 32px;
				padding: 5px 16px;
				border-radius: 2px;
				& + .el-button {
					margin-left: 16px;
				}
				span {
					display: flex;
					align-items: center;
				}
			}
			.el-button--default {
				border: 1px solid rgba(52, 145, 250, 1);
				color: rgba(52, 145, 250, 1);
				.iconpark-icon {
					font-size: 16px;
					margin-right: 4px;
				}
			}
			.el-button--primary {
				background: rgba(52, 145, 250, 1);
			}
			.iconpark-icon {
				fill: rgba(52, 145, 250, 1);
			}
		}
	}
	.questionnaire_wrap {
		height: 100%;
	}
	.questionnaire-container {
		height: 100%;
	}
}
.questionnaire_wrap_pc {
	flex: 1;
	padding: 32px 0;
	overflow: auto;
	// background: rgba(242, 243, 245, 1);
	// overflow: auto;
}
</style>
